// extracted by mini-css-extract-plugin
export default {"wrapper":"classes_wrapper__sJ9eX"};